import { ORDERS_ENDPOINTS } from "./endpoints";
import type { GetOrdersOptions, GetOrdersResponse, BackendOrdersResponse } from "./types";
import { apiGet } from "../shared";
import { validateLimit, validateOffset, validateOrderStatus } from "./validators";

function validateQueryOptions(options: GetOrdersOptions): void {
  if (options.limit !== undefined) validateLimit(options.limit);
  if (options.offset !== undefined) validateOffset(options.offset);
  if (options.status) validateOrderStatus(options.status);
}

function buildQueryString(options: GetOrdersOptions = {}): string {
  const params = new URLSearchParams();
  if (options.limit !== undefined) params.append("limit", options.limit.toString());
  if (options.offset !== undefined) params.append("offset", options.offset.toString());
  if (options.status) params.append("status", options.status);
  return params.toString() ? `?${params.toString()}` : "";
}

export async function getOrders(options: GetOrdersOptions = {}): Promise<GetOrdersResponse> {
  validateQueryOptions(options);

  const url = `${ORDERS_ENDPOINTS.LIST}${buildQueryString(options)}`;
  const backendResult = await apiGet<BackendOrdersResponse>(url);

  return {
    success: backendResult.success,
    data: {
      orders: backendResult.data.items,
      pagination: backendResult.data.pagination,
    },
    meta: {
      queryTime: backendResult.metadata?.queryTime || 0,
      timestamp: backendResult.timestamp || new Date().toISOString(),
    },
  };
}

export default getOrders;
